import { P, FF } from "../../styles/tokens";

export default function DukyFab({ onClick }) {
  return (
    <button
      onClick={onClick}
      aria-label="Abrir Duky, asesora financiera"
      className="fade-slide-up"
      style={{
        position: "fixed", bottom: 28, right: 28, zIndex: 50,
        width: 56, height: 56, borderRadius: "50%",
        background: `linear-gradient(145deg, ${P.dark}, #0F172A)`,
        border: `3px solid ${P.surface}`,
        boxShadow: "0 8px 32px rgba(30,41,59,0.35)",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 24, cursor: "pointer",
      }}
    >
      🐿️
    </button>
  );
}
